export const INVESTMENTS = '/investments'
export const INVESTMENTS_METRICS_ID = '/investments/metrics/:id'

const investmentsRoutes = [INVESTMENTS, INVESTMENTS_METRICS_ID]

export default investmentsRoutes
